__turbopack_context__.v({
  "slider": "styles-module__SLaibW__slider",
  "small": "styles-module__SLaibW__small",
  "toggleLabels": "styles-module__SLaibW__toggleLabels",
  "toggleSwitcher": "styles-module__SLaibW__toggleSwitcher",
});
